import { render, staticRenderFns } from "./mainBlock.vue?vue&type=template&id=5d99c458&scoped=true&"
import script from "./mainBlock.vue?vue&type=script&lang=js&"
export * from "./mainBlock.vue?vue&type=script&lang=js&"
import style0 from "./mainBlock.vue?vue&type=style&index=0&id=5d99c458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99c458",
  null
  
)

export default component.exports